// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  paymentsLinkDetails: Object,
};

const DeleteSelectedPaymentLink = (props: Props) => {
  const {
    visible,
    close,
    submit,
    paymentsLinkDetails,
  } = props;

  const deleteSelectedPaymentLink = () => {
    submit(paymentsLinkDetails.gid);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">No, dont cancel</SpButton>,
        <SpButton onClick={deleteSelectedPaymentLink} type="danger">Yes, cancel</SpButton>,
      ]}
      title="Cancel Payment Link"
    >
      <div className="px-4">
        <h6 className="mt-1 mb-2">Are you sure you want to cancel this Payment Link?</h6>
        <SpH5 className="pb-3">
          <div>{paymentsLinkDetails.name ? paymentsLinkDetails.name : <>&#8211;</>}</div>
        </SpH5>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default DeleteSelectedPaymentLink;
